import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function UpdateConfirmationModal({
  displayText,
  isOpen,
  onClose,
  onSave,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'courses.UpdateConfirmationModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const onSaveClick = () => {
    onClose();
    onSave();
  };

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton color='mint' onClick={onSaveClick}>
            {i18nTShared('saveChanges')}
          </FilledButton>
        </div>
      }
      isOpen={isOpen}
      mode='flexible'
      onClose={onClose}
    >
      <div className='tw-p-8'>
        <h2 className='tw-m-0 tw-p-0 tw-text-l tw-font-semibold tw-text-grey-900'>
          {i18nT('title')}
        </h2>
        <p className='tw-m-0 tw-mt-5 tw-rounded-lg tw-border-0 tw-bg-red-025 tw-p-3 tw-text-red-800'>
          {displayText}
        </p>
      </div>
    </ModalBox>
  );
}

UpdateConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  displayText: PropTypes.string.isRequired,
};
